import { Routes, RouterModule } from '@angular/router';

//Route for content layout with sidebar, navbar and footer.
// import { VendedoresGuardService } from '../../service/vendedores/vendedores-guard.service';

export const full_routes: Routes = [
  // Categorias
  {
    path: 'categorias',
    loadChildren: () => import('../../features/categorias/categorias.module').then((m) => m.CategoriasModule),
  },
  // IA
  {
    path: 'ia',
    loadChildren: () => import('../../features/ia/ia.module').then((m) => m.IaModule),
  },
  // Toppings
  {
    path: 'toppings',
    loadChildren: () => import('../../features/toppings/toppings.module').then((m) => m.ToppingsModule),
  },
  // Account
  {
    path: 'myAccount',
    loadChildren: () => import('../../features/account/account.module').then((m) => m.AccountModule),
  },
  // Tags
  {
    path: 'etiquetas',
    loadChildren: () => import('../../features/tags/etiquetas.module').then((m) => m.TagsModule),
  },
  // Artists
  {
    path: 'artistas',
    loadChildren: () => import('../../features/artists/artists.module').then((m) => m.ArtistsModule),
  },
  // Compartir
  {
    path: 'compartir',
    loadChildren: () => import('../../features/compartir/compartir.module').then((m) => m.CompartirModule),
  },
  // Planes
  {
    path: 'planes',
    loadChildren: () => import('../../features/planes/planes.module').then((m) => m.PlanesModule),
  },
  // Soporte
  {
    path: 'soporte',
    loadChildren: () => import('../../features/soporte/soporte.module').then((m) => m.SoporteModule),
  },
  // Settings
  {
    path: 'settings',
    loadChildren: () => import('../../features/configuration/configuration.module').then((m) => m.ConfigurationModule),
  },
  // Reportes
  {
    path: 'reportes',
    loadChildren: () => import('../../features/reportes/reportes.module').then((m) => m.ReportesModule),
  },
  // Estadisticas
  {
    path: 'estadisticas',
    loadChildren: () => import('../../features/estadisticas/estadisticas.module').then((m) => m.EstadisticasModule),
  },
  // Configuracion
  {
    path: 'configuracion',
    loadChildren: () => import('../../features/configuration-home/configuration-home.module').then((m) => m.ConfigurationHomeModule),
  },
  // Planes
  {
    path: 'planes',
    loadChildren: () => import('../../features/planes/planes.module').then((m) => m.PlanesModule),
  },
  // Afinidades
  {
    path: 'afinidades',
    loadChildren: () => import('../../features/afinidades/afinidades.module').then((m) => m.AfinidadesModule),
  },
  // Tiendas
  {
    path: 'tiendas',
    loadChildren: () => import('../../features/tiendas/tiendas.module').then((m) => m.TiendasModule),
  },
  // Image Gallery
  {
    path: 'imageGallery',
    loadChildren: () => import('../../features/gallery-uploader/galleryUploader.module').then((m) => m.GalleryUploaderModule),
  },
  // Vendedores
  {
    path: 'vendedores',
    loadChildren: () => import('../../features/vendedores/vendedores.module').then((m) => m.VendedoresModule),
  },
  // PDF Templates
  {
    path: 'templates',
    loadChildren: () => import('../../features/pdfTemplates/pdfTemplate.module').then((m) => m.pdfTemplateModule),
  },
  // Users
  {
      path: 'users_store',
      loadChildren: () => import('../../features/users/users.module').then((m) => m.UsersModule),
  },
  //Productos
  {
    path: 'productos',
    loadChildren: () => import('../../features/productos/productos.module').then((m) => m.ProductosModule),
  },
  //Design
  {
    path: 'diseño',
    loadChildren: () => import('../../features/design/design.module').then((m) => m.DesignModule),
  },
  //Exportar
  {
    path: 'exportar',
    loadChildren: () => import('../../features/menupdf/menupdf.module').then((m) => m.MenuPdfModule),
  },
  //Clientes
  {
    path: 'clientes',
    loadChildren: () => import('../../features/clientes/clientes.module').then((m) => m.ClientesModule),
  },
  //Envios
  {
    path: 'envios',
    loadChildren: () => import('../../features/envios/envios.module').then((m) => m.EnviosModule),
  },
  // Pedidos
  {
    path: 'pedidos',
    loadChildren: () => import('../../features/pedidos/pedidos.module').then((m) => m.PedidosModule),
  },

  // {
  //   path: 'clientes',
  //   loadChildren: () => import('../../views/clientes/clientes.module').then((m) => m.ClientesModule),
  // },
  // {
  //   path: 'envios',
  //   loadChildren: () => import('../../views/envios/envios.module').then((m) => m.EnviosModule),
  // },
  // {
  //   path: 'vendedores',
  //   loadChildren: () => import('../../views/vendedores/vendedores.module').then((m) => m.VendedoresModule),
  //   canActivate: [VendedoresGuardService],
  // },
  // {
  //   path: 'tiendas',
  //   loadChildren: () => import('../../views/tiendas/tiendas.module').then((m) => m.TiendasModule),
  // },
  // {
  //   path: 'users_store',
  //   loadChildren: () => import('../../views/users/users.module').then((m) => m.UsersModule),
  // },
  // {
  //   path: 'productos',
  //   loadChildren: () => import('../../views/productos/productos.module').then((m) => m.ProductosModule),
  // },
  // {
  //   path: 'planes',
  //   loadChildren: () => import('../../views/planes/planes.module').then((m) => m.PlanesModule),
  // },
  // {
  //   path: 'exportar',
  //   loadChildren: () => import('../../views/menupdf/menupdf.module').then((m) => m.MenuPdfModule),
  // },
  // {
  //   path: 'diseño',
  //   loadChildren: () => import('../../views/design/design.module').then((m) => m.DesignModule),
  // },
  // {
  //   path: 'categorias',
  //   loadChildren: () => import('../../views/categorias/categorias.module').then((m) => m.CategoriasModule),
  // },
  // {
  //   path: 'toppings',
  //   loadChildren: () => import('../../views/toppings/toppings.module').then((m) => m.ToppingsModule),
  // },
  // {
  //   path: 'imageGallery',
  //   loadChildren: () => import('../../views/gallery-uploader/galleryUploader.module').then((m) => m.GalleryUploaderModule),
  // },
  // {
  //   path: 'afinidades',
  //   loadChildren: () => import('../../views/afinidades/afinidades.module').then((m) => m.AfinidadesModule),
  // },
  // {
  //   path: 'ia',
  //   loadChildren: () => import('../../views/ia/iframe.module').then((m) => m.IframeModule),
  // },
  // {
  //   path: 'etiquetas',
  //   loadChildren: () => import('../../views/tags/etiquetas.module').then((m) => m.TagsModule),
  // },
  // {
  //   path: 'artistas',
  //   loadChildren: () => import('../../views/artists/artists.module').then((m) => m.ArtistsModule),
  // },
  // {
  //   path: 'templates',
  //   loadChildren: () => import('../../views/pdfTemplates/pdfTemplate.module').then((m) => m.pdfTemplateModule),
  // },
  // // {
  // //   path: 'turnos',
  // //   loadChildren: () => import('../../views/turnos/turnos.module').then(m => m.TurnosModule)
  // // },
  // {
  //   path: 'pedidos',
  //   loadChildren: () => import('../../views/pedidos/pedidos.module').then((m) => m.PedidosModule),
  // },
  // {
  //   path: 'compartir',
  //   loadChildren: () => import('../../views/compartir/compartir.module').then((m) => m.CompartirModule),
  // },
  // {
  //   path: 'configuracion',
  //   loadChildren: () => import('../../views/configurationHome/configuration-home.module').then((m) => m.ConfigurationHomeModule),
  // },
  // {
  //   path: 'wholesales',
  //   loadChildren: () => import('../../views/wholesales/wholesales.module').then((m) => m.WholesalesModule),
  // },
  // {
  //   path: 'estadisticas',
  //   loadChildren: () => import('../../views/estadisticas/estadisticas.module').then((m) => m.EstadisticasModule),
  // },
  // {
  //   path: 'reportes',
  //   loadChildren: () => import('../../views/reportes/reportes.module').then((m) => m.ReportesModule),
  // },
  // {
  //   path: 'promociones',
  //   loadChildren: () => import('../../views/promociones/promociones.module').then((m) => m.PromocionesModule),
  // },
  // {
  //   path: 'whatsapp',
  //   loadChildren: () => import('../../views/whatsapp/whatsapp.module').then((m) => m.WhatsappModule),
  // },
  // {
  //   path: 'checkout-forms',
  //   loadChildren: () => import('../../views/checkoutForms/checkout-forms.module').then((m) => m.CheckoutFormsModule),
  // },
  // {
  //   path: 'variantes',
  //   loadChildren: () => import('../../views/variantes/variantes.module').then((m) => m.VariantesModule),
  // },
  // {
  //   path: 'campaign',
  //   loadChildren: () => import('../../views/campaing/campaing.module').then((m) => m.CampaingModule),
  // },
  // {
  //   path: 'settings',
  //   loadChildren: () => import('../../views/configuration/configuration.module').then((m) => m.ConfigurationModule),
  // },
  // {
  //   path: 'myAccount',
  //   loadChildren: () => import('../../views/account/account.module').then((m) => m.AccountModule),
  // },
];
